import React from "react";
import {
  SettingsSection,
  SettingsSectionHeader,
  SettingsSectionContent,
} from "components/Graphs/SettingsSection";

const DeleteAccount = () => {
  return (
    <SettingsSection>
      <SettingsSectionHeader title="Delete Account" />
      <SettingsSectionContent>
        <div className="text-white gap-2 flex flex-col">
          <p className="text-sm text-secondary">
            Visit the{" "}
            <a
              href={import.meta.env.VITE_PRIVATE_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-highlight cursor-pointer"
            >
              NVIDIA Privacy Center
            </a>{" "}
            and navigate to <span className="font-medium">NVIDIA Accounts</span>{" "}
            an then <span className="font-medium">Delete All Data</span> to
            request deletion of all your data stored by NVIDIA.
          </p>
        </div>
      </SettingsSectionContent>
    </SettingsSection>
  );
};

export default DeleteAccount;
